var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGetPasses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 19H26.125C26.125 19 28.5 30.875 40.375 30.875C52.25 30.875 54.625 19 54.625 19H104.5V95H54.625C54.625 95 52.25 83.125 40.375 83.125C28.5 83.125 26.125 95 26.125 95H9.5V19Z",
    stroke: "#636365",
    strokeWidth: 6.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.375 45.125V49.875",
    stroke: "#636365",
    strokeWidth: 6.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.375 64.125V68.875",
    stroke: "#636365",
    strokeWidth: 6.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.375 49.875H85.5",
    stroke: "#636365",
    strokeWidth: 6.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.375 64.125H85.5",
    stroke: "#636365",
    strokeWidth: 6.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetPasses);
export default __webpack_public_path__ + "static/media/getPasses.4d772e6f.svg";
export { ForwardRef as ReactComponent };